export const dailyAttendanceData = [
  {
    Key: "1",
    class: "III",
    section: "A",
    present: "69",
    absent: "2",
    percentange: "98%",
    absentPercentange: "2%",
  },
  {
    Key: "2",
    class: "IV",
    section: "A",
    present: "45",
    absent: "7",
    percentange: "78%",
    absentPercentange: "22%",
  },
  {
    Key: "3",
    class: "II",
    section: "B",
    present: "69",
    absent: "8",
    percentange: "89%",
    absentPercentange: "11%",
  },
  {
    Key: "4",
    class: "I",
    section: "C",
    present: "54",
    absent: "7",
    percentange: "98%",
    absentPercentange: "1%",
  },
  {
    Key: "5",
    class: "II",
    section: "A",
    present: "65",
    absent: "1",
    percentange: "98%",
    absentPercentange: "2%",
  },
  {
    Key: "6",
    class: "III",
    section: "B",
    present: "78",
    absent: "2",
    percentange: "72%",
    absentPercentange: "28%",
  },
  {
    Key: "7",
    class: "V",
    section: "C",
    present: "65",
    absent: "0",
    percentange: "100%",
    absentPercentange: "0%",
  },
  {
    Key: "8",
    class: "VI",
    section: "A",
    present: "45",
    absent: "2",
    percentange: "98%",
    absentPercentange: "1%",
  },
  {
    Key: "9",
    class: "VIII",
    section: "B",
    present: "47",
    absent: "2",
    percentange: "98%",
    absentPercentange: "2%",
  },
  {
    Key: "10",
    class: "VII",
    section: "C",
    present: "45",
    absent: "7",
    percentange: "89%",
    absentPercentange: "11%",
  },
  {
    Key: "11",
    class: "IX",
    section: "A",
    present: "45",
    absent: "1",
    percentange: "98%",
    absentPercentange: "2%",
  },
];
